export default __webpack_public_path__ + "static/media/logoheader.7721697d.svg";